export default {
  getLogPower: "/report/getLogPower",
  getPowerOverview: "/report/power/overview",
  getMonthlyYearComparison: "/report/power/monthly-year-comparison",
  getEnergyShare: "/report/power/energy-share",
  getMonthlyEnergyList: "/report/power/monthly-energy-list",
  getEnergyTrend: "/report/power/energy-trend",
  getHemsOverview: "/report/hems/overview",
  getFloorPeriodComparison: "/report/power/floor-period-comparison",
  getMonthlyGrowthStatistics: "/report/power/monthly-growth-statistics",
  getOptimalContractCapacity: "/report/power/optimal-contract-capacity",
  getMultiPeriodComparison: "/report/power/multi-period-comparison",
  getFloorDailyComparison: "/report/power/floor-daily-comparison",
  getGreenEnergyDashboard: "/report/power/green-energy-dashboard",
  getAreaPerformance: "/report/power/area-performance",
  getDemandManagement: "/report/power/demand-management",
  getTimeOfUseStatistics: "/report/power/time-of-use-statistics",
  getFloorMonthlyComparison: "/report/power/floor-monthly-comparison",
  getLogPowerElectricityPrices: "report/getLogPowerElectricityPrices",
  getPublicLogPower: "report/getPublicLogPower",
  getBuildingList: "report/getBuildingList",
  getEnergyList: "report/getEnergyList",
};
